var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEditWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_461_7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.16669 8.16667H7.00002C6.38118 8.16667 5.78769 8.4125 5.3501 8.85008C4.91252 9.28767 4.66669 9.88116 4.66669 10.5V21C4.66669 21.6188 4.91252 22.2123 5.3501 22.6499C5.78769 23.0875 6.38118 23.3333 7.00002 23.3333H17.5C18.1189 23.3333 18.7124 23.0875 19.1499 22.6499C19.5875 22.2123 19.8334 21.6188 19.8334 21V19.8333",
    stroke: "white",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7825 7.6825C24.242 7.22301 24.5001 6.59981 24.5001 5.95C24.5001 5.30019 24.242 4.67699 23.7825 4.2175C23.323 3.75801 22.6998 3.49988 22.05 3.49988C21.4002 3.49988 20.777 3.75801 20.3175 4.2175L10.5 14V17.5H14L23.7825 7.6825Z",
    stroke: "white",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6667 5.83333L22.1667 9.33333",
    stroke: "white",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_461_7"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEditWhite);
export default __webpack_public_path__ + "static/media/Icon_Edit_White.3e78b1543bbbc1443e56f95d16eed6ea.svg";
export { ForwardRef as ReactComponent };